import * as XLSX from "xlsx";
import type { Celula } from "@bookdental/schemas";

export type Planilha = { nome: string; linhas: Celula[][] };

/**
 * A primeira aba com as células cruas: data como Date e número como número. O leitor da importação
 * de pacientes usa os textos formatados, e o SheetJS formata data no padrão americano ("1/15/26").
 */
export async function lerPlanilha(file: File): Promise<Planilha> {
  const wb = XLSX.read(await file.arrayBuffer(), { type: "array", cellDates: true });
  const aba = wb.SheetNames[0];
  if (!aba) throw new Error("Arquivo sem planilhas.");
  const linhas = XLSX.utils.sheet_to_json<Celula[]>(wb.Sheets[aba]!, { header: 1, raw: true, defval: "", blankrows: false });
  if (!linhas.length) throw new Error("Planilha vazia.");
  return { nome: file.name, linhas };
}

/** O texto de uma célula para mostrar (cabeçalho, amostra). */
export function celulaEmTexto(c: Celula): string {
  if (c instanceof Date) return c.toLocaleDateString("pt-BR");
  if (typeof c === "number") return c.toLocaleString("pt-BR");
  return c == null ? "" : String(c).trim();
}
